//* 组件库
import { utility } from "various-ui";

type DisposeOption = {
    size: number; //* 绘图区域
    rect: number; //* 柱子尺寸
    offset: number; //* 绘图左右间隔
};

export const useDrawingOption = (data: { name: string; number: number }[], option: DisposeOption) => {
    //* Y轴最值计算
    const extreme = data.reduce((result, value) => Math.max(result, value.number), 0);
    //* 绘图区域计算
    const area = option.size - option.offset * 2;
    //* 柱子之间的间隔计算
    const spacing = (area - data.length * option.rect) / (data.length + 1);
    if (spacing < 8) {
        //* 间隔小于8时，缩小柱子
        const rect = Math.floor((area - (data.length + 1) * 8) / data.length);
        return {
            rect: rect,
            ratio: utility.divide(240, extreme),
            spacing: (area - data.length * rect) / (data.length + 1),
        };
    } else {
        return {
            rect: 32,
            ratio: utility.divide(240, extreme),
            spacing: spacing,
        };
    }
};
